<template>
  <v-container fluid>
    <v-row v-if="team">
      <v-col cols="12" align="center" justify="center">
        <h1 class="mb-2">Team {{ team.name }}</h1>
        <h3>Lead by {{ teamLead }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="table.headers"
          :options="table.options"
          :items="leadDashboard"
          :search="search"
          :loading="loading"
          :hide-default-footer="true"
          disable-pagination
          fixed-header
          dense
        >
          <template v-slot:top>
            <v-text-field v-model="search" label="Search" class="mx-4">
            </v-text-field>
          </template>
          <template v-slot:[`item.coach`]="props">
            <router-link
              :to="props.item.coach_link"
              class="secondary--text text-body-1 text-decoration-none"
            >
              <strong>{{ props.item.coach }}</strong>
            </router-link>
          </template>
          <template v-slot:[`item.controls`]="props" width="100">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  elevation="13"
                  color="secondary"
                  class="ma-1"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="showManageClients(props.item)"
                >
                  <v-icon> mdi-clipboard-account </v-icon>
                </v-btn>
              </template>
              <span>Manage secondary clients</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-if="modal.show"
      v-model="modal.show"
      width="900"
      transition="dialog-bottom-transition"
      class="limited-height"
    >
      <client-management
        :coachId="modal.selectedCoachId"
        :existingBlock="modal.existingBlock"
        @close="closeManageClients()"
      ></client-management>
    </v-dialog>
  </v-container>
</template>

<script>
import { LEAD_DASHBOARD_QUERY } from "@/constants/graphql/coach/leadCoaches";
import ClientManagement from "../shared/ClientManagement";
import { getUserName } from "@/lib/username";

export default {
  name: "LeadsDashboard",
  props: [],
  components: {
    ClientManagement,
  },
  data() {
    return {
      loading: true,
      search: "",
      table: {
        options: {},
        headers: [
          { text: "Coach", value: "coach" },
          { text: "Current client-sitting Block", value: "secondaryPeriod" },
          {
            text: "",
            value: "controls",
            sortable: false,
            groupable: false,
            width: 165,
          },
        ],
      },
      team: null,
      modal: {
        show: false,
        selectedCoachId: null,
      },
    };
  },
  computed: {
    teamLead() {
      return getUserName(this.team.lead);
    },
  },
  methods: {
    showManageClients(coach) {
      this.modal = {
        show: true,
        selectedCoachId: coach.id,
        existingBlock: coach.coachSecondaryPeriod?.length > 0 ? coach.coachSecondaryPeriod[0] : null
      };
    },
    closeManageClients() {
      this.modal = {
        show: false,
        selectedCoachId: null,
      };
      this.$apollo.queries.leadDashboard.refetch();
    },
    compactDate(value) {
      return this.$moment(value)?.format("ddd, DD MMM");
    },
    getSecondaryCoachingDates(startDate, endDate) {
      return `${this.compactDate(startDate)} ${
        startDate == endDate ? "" : " - " + this.compactDate(endDate)
      }`;
    },
  },
  apollo: {
    leadDashboard: {
      query: LEAD_DASHBOARD_QUERY,
      fetchPolicy: "cache-and-network",
      result(response) {
        this.loading = false;
      },
      update(data) {
        data.leadCoaches.forEach((coach) => {
          coach.coach_link = `/dashboard/${coach.id}/clients/daily`;
          coach.coach = getUserName(coach);
          coach.secondaryPeriod =
            coach.coachSecondaryPeriod?.length > 0
              ? this.getSecondaryCoachingDates(
                  coach.coachSecondaryPeriod[0].startDate,
                  coach.coachSecondaryPeriod[0].endDate
                )
              : "-";
        });
        this.team = data.team;

        return data.leadCoaches;
      },
    },
  },
};
</script>